import { useMutation } from '@tanstack/react-query';

import type { NewPersona } from '../../../domain/persona';
import { useUseCases } from '../../../UseCaseProvider';

export const useCreatePersonaMutation = (onSuccess: () => void) => {
  const { createPersona } = useUseCases();
  return useMutation({
    mutationKey: ['create-persona'],
    mutationFn: (persona: NewPersona) => createPersona(persona),
    onSuccess,
  });
};
